import { useEffect, createContext, useContext } from 'react';
import { useAuthStore } from '../stores/authStore';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const fetchUser = useAuthStore((s) => s.fetchUser);
  const loading = useAuthStore((s) => s.loading);

  useEffect(() => { fetchUser(); }, [fetchUser]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-800" /></div>;
  }

  return <AuthContext.Provider value={true}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const store = useAuthStore();
  return {
    user: store.user,
    token: store.token,
    loading: store.loading,
    login: store.login,
    logout: store.logout,
    changePassword: store.changePassword,
    refreshUser: store.refreshUser
  };
};
